<template>
  <el-tooltip
    :hide-after="0"
    v-bind="$attrs"
    popper-class="id-tooltip"
    :effect="effect"
    :placement="placement"
    :offset="-20"
    ref="tooltip">
    <div slot="content" class="comp-indicator-description-content">
      <slot></slot>
      <div>
        <p :style="{'margin-bottom':desc.length !==0 ? '10px' : '0px'}" >{{title}}</p>
        <div v-for="(item,index) in desc" :key="index">
          <span>{{item.label}}</span>
          <p>{{item.value}}</p>
        </div>
      </div>
    </div>
    <div class="comp-indicator-description flex-between">
      <slot name="hover-btn">指标说明</slot>
      <i class="icon-shuoming iconfont icon"></i>
    </div>
  </el-tooltip>
</template>
<script>
  export default {
    props: {
      'placement': {
        type: String,
        default: 'bottom-end'
      },
      'effect': {
        type: String,
        default: 'light'
      },
      'title': {
        type: String,
        default: ''
      },
      'desc': {
        type: Array,
        default: () => []
      }
    },
    name: 'IndicatorDescription'
  };
</script>
<style lang="less">
  // 全局
  @bgd: #fffce0;
  @border: #e0dec8;
  @iconColor: #016cdf;
  @textColor: #666666;
  .id-tooltip {
    &.el-tooltip__popper.is-light {
      background: @bgd;
      border: 1px solid @border;
    }
    &.el-tooltip__popper.is-light .popper__arrow {
      border-bottom-color: @border;
      border-top-color: @border;
    }
    &.el-tooltip__popper.is-light .popper__arrow::after {
      border-bottom-color: @bgd;
      border-top-color: @bgd;
    }
  }

  .comp-indicator-description {
    min-width: 75px;
    span {
      font-size: 12px;
      color: @textColor;
      display: inline-block;
      vertical-align: top;
      width: 200px;
    }
    .icon {
      color: @iconColor;
      font-size: 14px;
    }
  }

  // 优化指标说明类型
  .comp-indicator-description-content {
    div {
      div {
        overflow: hidden;
        margin: 5px 0;
        span {
          margin-right: 15px;
          display: inline-block;
          width: 120px;
          text-align: left;
          float: left;
        }
        p {
          display: inline-block;
          max-width: 370px;
          float: left;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// IndicatorDescription.vue?66198d4c